import type { TokenDefinition, } from "../../types"


export const definitions: TokenDefinition[] = [
	{
		name: "Ethereum",
		symbol: "ETH",
		label: "ETH",
		chainId: 42161,
		decimals: 18,
		logoURI: "https://cdn.iconscout.com/icon/free/png-256/free-ethereum-1824287-1545899.png",
		address: "0x0",
		extensions: { },
		fees: [ ],
		swapable: true,
		parity: true,
		swapto: false,
	},
	{
		name: "wrapped ether",
		symbol: "WETH",
		label: "wETH",
		chainId: 42161,
		address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
		extensions: {
			"bridgeInfo": {
				"10": {
					"tokenAddress": "0x4200000000000000000000000000000000000006"
				},
				"56": {
					"tokenAddress": "0x2170Ed0880ac9A755fd29B2688956BD959F933F8"
				},
				"137": {
					"tokenAddress": "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
				},
				"8453": {
					"tokenAddress": "0x4200000000000000000000000000000000000006"
				},
				"42161": {
					"tokenAddress": "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
				},
				"42220": {
					"tokenAddress": "0x2DEf4285787d58a2f811AF24755A8150622f4361"
				},
				"43114": {
					"tokenAddress": "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB"
				}
			}
		},
		fees: [ ],
		swapable: true,
		parity: true,
		swapto: false,
	},
	{
		name: "ankrETH",
		symbol: "ANKRETH",
		label: "ankrETH",
		chainId: 42161,
		address: "0xe05A08226c49b636ACf99c40Da8DC6aF83CE5bB3",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978",
		extensions: {
			"bridgeInfo": {
				"56": {
					"tokenAddress": "0xf307910A4c7bbc79691fD374889b36d8531B08e3"
				},
				"42161": {
					"tokenAddress": "0x1bfc5d35bf0f7B9e15dc24c78b8C02dbC1e95447"
				},
				"43114": {
					"tokenAddress": "0x20CF1b6E9d856321ed4686877CF4538F2C84B4dE"
				}
			}
		},
		fees: [ ],
		stakable: true,
		parity: false,
		swapto: false,
		disabled: true,
	},
	{
		name: "wrapped liquid staked ether",
		symbol: "WSTETH",
		label: "wstETH",
		chainId: 42161,
		address: "0x5979D7b546E38E414F7E9822514be443A4800529",
		decimals: 18,
		logoURI: "https://etherscan.io/token/images/wsteth3_32.png",
		extensions: { },
		fees: [ 100, ],
		stakable: true,
		parity: false,
		swapto: true,
	},
	{
		name: "rocket pool ether",
		symbol: "RETH",
		label: "rETH",
		chainId: 42161,
		address: "0xEC70Dcb4A1EFa46b8F2D97C310C9c4790ba5ffA8",
		decimals: 18,
		logoURI: "https://etherscan.io/token/images/rocketpooleth_32.png?v=2",
		extensions: {

		},
		fees: [ 500, 3000 ],
		stakable: true,
		parity: false,
		swapto: true,
	},
	{
		name: "rsETH",
		symbol: "RSETH",
		label: "rsETH",
		chainId: 42161,
		address: "0x4186BFC76E2E237523CBC30FD220FE055156b41F",
		decimals: 18,
		logoURI: "https://img.cryptorank.io/coins/60x60.kelp_dao_restaked_eth1716362924229.png",
		extensions: { },
		fees: [ 10000, 3000, 500 ],
		stakable: true,
		parity: false,
		swapto: true,
	},
	{
		name: "wrapped eETH",
		symbol: "WEETH",
		label: "weETH",
		chainId: 42161,
		address: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
		decimals: 18,
		logoURI: "https://arbiscan.io/token/images/etherfiweeth_32.png",
		extensions: { },
		fees: [ 100, 3000, ],
		stakable: true,
		parity: false,
		swapto: true,
	},
	{
		name: "ezETH",
		symbol: "EZETH",
		label: "ezETH",
		chainId: 42161,
		address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
		decimals: 18,
		logoURI: "https://etherscan.io/token/images/ezETHv2_32.png",
		extensions: { },
		fees: [ 100, 10000, 500, ],
		stakable: true,
		parity: false,
		swapto: true,
		inactive: true,
		disabled: true,
	},
	{
		name: "osETH",
		symbol: "OSETH",
		label: "osETH",
		chainId: 42161,
		address: "0xf7d4e7273E5015C96728A6b02f31C505eE184603",
		decimals: 18,
		logoURI: "/assets/crypto/oseth.png",
		extensions: { },
		fees: [ 100, 10000, 500, ],
		stakable: true,
		parity: false,
		swapto: false,
		disabled: true,
	},
];
